module.exports = __webpack_public_path__ + "img/logo.721e2278.jpg";